import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57d1beda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Connect "),
  /*#__PURE__*/_createElementVNode("span", { class: "asana-color" }, "Asana"),
  /*#__PURE__*/_createTextVNode(" to continue.")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "asana" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Connect Asana ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import { fetchData } from "@/api"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const asanaLogin = async () => {
  const data = await fetchData(`${process.env.VUE_APP_API_URL}/asana/login`)

  if (data) {
    window.location.href = data.asana_oauth_url
  }

  // console.log(data)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (asanaLogin()))
    }, _hoisted_5)
  ]))
}
}

})